import { render, staticRenderFns } from "./NirvarLimitSearch.vue?vue&type=template&id=89985950&"
import script from "./NirvarLimitSearch.vue?vue&type=script&lang=js&"
export * from "./NirvarLimitSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports